import { useMemo } from "react";
import Hero from "@/components/Hero";
import IntroSection from "@/components/IntroSection";
import ScrollVelocitySection from "@/components/ScrollVelocitySection";
import LastYearSection from "@/components/LastYearSection";

import BigWordsSection from "@/components/BigWordsSection";
import StayInTheKnow from "@/components/StayInTheKnow";
import { TicketCTA } from "@/components/Sections";
import SponsorsBlock from "@/components/SponsorsBlock";
import CrewSection from "@/components/CrewSection";
import TravelQuickAccess from "@/components/TravelQuickAccess";
import Footer from "@/components/Footer";
import EarlyAccessModal from "@/components/EarlyAccessModal";
import { usePageSEO } from "@/hooks/use-page-seo";
import { buildMusicEventSchema } from "@/lib/event-schema";

const Index = () => {
  const eventJsonLd = useMemo(() => buildMusicEventSchema({
    url: "https://yachtrockdetroit.com",
    description: "Yacht Rock Detroit 2026 — Detroit's two-day waterfront music festival at The Roostertail, July 17-18. Live concerts featuring Three Dog Night, Pablo Cruise, Ambrosia, Yacht Rock Revue, and more. Summer concerts on the Detroit River with sunset views, craft cocktails, and the smoothest music ever made.",
  }), []);

  const orgJsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Yacht Rock Detroit",
    "url": "https://yachtrockdetroit.com",
    "logo": "https://yachtrockdetroit.com/favicon.svg",
    "sameAs": [
      "https://www.instagram.com/yachtrockdetroit/",
      "https://www.facebook.com/yachtrockdetroit/"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-313-822-1234",
      "contactType": "customer service",
      "email": "hello@yachtrockdetroit.com"
    }
  }), []);

  const webSiteJsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Yacht Rock Detroit",
    "url": "https://yachtrockdetroit.com"
  }), []);

  usePageSEO({
    title: "Yacht Rock Detroit | Waterfront Festival at The Roostertail — Summer 2027",
    description: "Yacht Rock Detroit returns to The Roostertail summer 2027. Sign up for early access — dates, lineup, and tickets before the public.",
    canonical: "https://yachtrockdetroit.com/",
    keywords: "yacht rock detroit, yacht rock detroit 2027, detroit summer festival 2027, concert detroit, summer concerts detroit, detroit waterfront music festival, live music detroit, roostertail detroit, detroit concert festival",
    jsonLd: [eventJsonLd, orgJsonLd, webSiteJsonLd],
  });

  return (
    <main>
      <Hero />

      <TicketCTA />
      <IntroSection />
      <section className="bg-yacht-cream pb-16 md:pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <SponsorsBlock />
        </div>
      </section>
      <BigWordsSection />
      <LastYearSection />
      <ScrollVelocitySection />
      <CrewSection />
      <TravelQuickAccess />
      <StayInTheKnow />
      <Footer />
      <EarlyAccessModal />
    </main>
  );
};

export default Index;
